import { format } from 'app/shared/utils/string.util';

import { IViolation } from '../base/annotation';
import { DataFlowSink } from './dataflow-sink';
import { DataFlowSource } from './dataflow-source';
import { DataFlowExpression } from './dataflowexpression';

export function workspaceDatabaseValidator(owner: DataFlowSource | DataFlowSink, value?: DataFlowExpression): IViolation[] | undefined {
    const violations = [];
    if (owner.isWorkspaceDatabase) {
        if (!value.expression) {
            violations.push({
                message: () => format(stringResources.RequiredTemplate, stringResources.Database),
                context: owner
            });
        }
    }

    return violations.length > 0 ? violations : undefined;
}

export function workspaceTableValidator(owner: DataFlowSource | DataFlowSink, value?: DataFlowExpression): IViolation[] | undefined {
    const violations = [];
    if (owner.isWorkspaceDatabase) {
        if (!value.expression) {
            violations.push({
                message: () => format(stringResources.RequiredTemplate, stringResources.ModelName_Table),
                context: owner
            });
        }
    }

    return violations.length > 0 ? violations : undefined;
}
